/*
 * Error codes created by the SockJsStreamingService
 */
export enum SockJsStreamingServiceErrorCodes {
    Indigo1SessionTimeoutOrInvalidation = 10000,
    Indigo1ServerShuttingDown = 10001,
    ResendFailed = 10002,
}

/*
 * Custom error codes from Indigo2 Websocket implementation as defined in https://confluence.dev.instinet.com/display/IN2/Remote+Stream+Protocol
 */
export enum WellKnownWebsocketErrorCodes {
    InitError = 4000,
    SessionAuthError = 4001,
    Indigo1StreamInitError = 4002,
    Indigo1StreamLost = 4003,
    InvalidIndigo2Request = 4004,
    Indigo1RequestError = 4005,
    Indigo1StreamError = 4006,
    UnhandledError = 4007,
    UnsupportedOperation = 4008,
    TransportError = 4009,
}
export function isWellKnownWebsocketErrorCode(code: number) {
    return (
        code >= WellKnownWebsocketErrorCodes.InitError &&
        code <= WellKnownWebsocketErrorCodes.TransportError
    );
}

/*
 * Spring Websocket API error close statuses from https://docs.spring.io/spring-framework/docs/current/javadoc-api/org/springframework/web/socket/CloseStatus.html.
 * Many of these are mapped to our custom error codes defined in https://confluence.dev.instinet.com/display/IN2/Remote+Stream+Protocol
 */
export enum WellKnownSpringWebSocketCloseStatus {
    GoingAway = 1001,
    ProtocolError = 1002,
    NotAcceptable = 1003,
    NoStatusCode = 1005,
    NoCloseFrame = 1006,
    BadData = 1007,
    PolicyViolation = 1008,
    TooBigToProcess = 1009,
    RequiredExtension = 1010,
    ServerError = 1011,
    ServiceRestarted = 1012,
    ServiceOverload = 1013,
    TlsHandshakeFailure = 1015,
}

export function isSpringWebSocketCloseStatus(code?: number) {
    return code && code >= 1000 && code <= 1999;
}
